import { render, staticRenderFns } from "./VSidebarPhotoEditor.vue?vue&type=template&id=64cd1ed8&scoped=true&"
import script from "./VSidebarPhotoEditor.vue?vue&type=script&lang=js&"
export * from "./VSidebarPhotoEditor.vue?vue&type=script&lang=js&"
import style0 from "./VSidebarPhotoEditor.vue?vue&type=style&index=0&id=64cd1ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd1ed8",
  null
  
)

export default component.exports